// module.formDirective('jobPlacementForm', function() {
//     return {
//         modelName: 'student',
//         subModel: 'job_placement',
//         templateDirectory: 'students/placements',
//     };
// });


module.directive('jobPlacementForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/jobPlacementForm',
        scope: {placement: '='},
        require: '^basicForm',
        link: function(scope, element, data, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(
                scope.placement,
                ['employer', 'green_job', 'job_type', 'wage', 'job_hours',
                 'national_service', 'stipend']);


            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.placement, data);
            }
        }

    };
});


module.directive('jobEndDateForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/jobEndDateForm',
        scope: {placement: '='},
        require: '^basicForm',
        link: function(scope, element, data, basicForm) {
            scope.data = basicForm.data = {};
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.placement, {
                    job_end: data.job_end,
                });
            };
        },
    };
});


module.directive('jobDatesForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'students/placements/jobDatesForm',
        scope: {placement: '='},
        require: '^basicForm',
        link: function(scope, element, data, basicForm) {
            scope.data = basicForm.data = ModelService.copyFields(scope.placement,
                ['job_start', 'job_end']);
            scope.form = basicForm.getForm();

            basicForm.save = function(data) {
                if (!scope.placement.job_end) {
                    delete data.job_end;
                }
                return ModelService.patchModel(scope.placement, data);
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.patchModel(scope.placement, {
                    job_end: null,
                });
            }, function() {
                return !!scope.placement.job_end;
            });
        },
    };
});